import { withStyles } from '@material-ui/core/styles';
import GrainIcon from '@material-ui/icons/Grain';
import ReorderIcon from '@material-ui/icons/Reorder';
import PropTypes from 'prop-types';
import React from 'react';
import { APPLICATION_PATHS } from '../../application-core/constants';
import ExternalResourceLink from '../../core/ExternalResourceLink';
import { globalStyles as styles } from '../../core/style/gstheme';
import withGS from '../../core/withGShoc';
import ConceptLink from '../core/ConceptLink';
import LabelLink from '../core/LabelLink';
import SchemeChip from '../core/SchemeChip';
import FloatingLabelRelationshipLink from './FloatingLabelRelationshipsLink';
import FloatingRelationshipLink from './FloatingRelationshipsLink';
import { CONCEPT_LOAD_OPTIONS } from '../../core/utils/constants';

class IriDisplay extends React.Component {

  render() {

    const { data, id, components, defaultLang, viewLang, graph, projectIRI, compact, onLink, wrap,
      property, source, onDeleteIRI, propertyGraph, otherScheme, useIfWorkflow } = this.props;

    const isNotLoaded = data._notAvailable;
    // Works whether an array or not
    const isInScheme = data.inScheme && data.inScheme.length > 0 ? true : false;
    // Sometimes might be list of component IRIs and sometimes data objects
    const isProjectLink = components && isInScheme && components.some(co => co.id ? data.inScheme.includes(co.id) : data.inScheme.includes(co));
    let link = APPLICATION_PATHS.TAXONOMY_MANAGER;
    const dataTypes = data.type ?
      Array.isArray(data.type) ?
        data.type
        :
        [data.type]
      :
      [];
    if (isProjectLink) {
      let schemeToUse = isInScheme ?
        Array.isArray(data.inScheme) ?
          data.inScheme[0]
          :
          data.inScheme
        :
        null;
      // If there is more than one scheme we try to find one with workflow activated is we are told to use workflow
      if (useIfWorkflow && components && components.length > 0 && Array.isArray(data.inScheme)) {
        const schemeWithWorkflow = data.inScheme.find(s => components.find(c => c.id === s && useIfWorkflow));
        if (schemeWithWorkflow) schemeToUse = schemeWithWorkflow;
      }
      link += '/project/taxonomy#project=' + projectIRI + "&taxonomy=" + schemeToUse;
      if (dataTypes.includes("Label")) {
        link += "&view=label&label=" + data.id;
      }
      else {
        link += "&view=concept&concept=" + data.id;
      }
    }
    else if (!isNotLoaded && !isInScheme && (data.type === "ConceptScheme" || data.type === "Collection" || data.type === "OrderedCollection")) {
      let componentLink = ["Collection", "OrderedCollection"].includes(data.type) ?
        '/project/collection#project=' + projectIRI + "&collection=" + data.id
        :
        '/project/taxonomy#project=' + projectIRI + "&taxonomy=" + data.id;
      link += componentLink;
    }
    else if (!isNotLoaded) {
      link += '/project/floating#project=' + projectIRI;
      if (data.type === "Label") {
        link += "&view=label&label=" + data.id;
      }
      else {
        link += "&view=concept&concept=" + data.id;
      }
    }

    let output;
    if (isProjectLink && dataTypes.includes("Label")) {
      output = <LabelLink
        link={link}
        onLink={onLink}
        compact={true}
        id={data.id}
        graph={graph}
        isReadOnly={true}
        defaultLang={defaultLang} />;
    }
    else if (isProjectLink && dataTypes.includes("Concept")) {
      output = <ConceptLink
        link={link}
        onLink={onLink}
        onDeleteIRI={onDeleteIRI}
        source={source}
        target={data.id}
        compact={compact}
        propertyGraph={propertyGraph}
        id={data.id}
        otherScheme={otherScheme}
        graph={graph}
        property={property}
        isReadOnly={!source && !onDeleteIRI}
        viewLang={viewLang}
        defaultLang={defaultLang} />;
    }
    else if (!isInScheme && (data.type === "ConceptScheme" || data.type === "Collection" || data.type === "OrderedCollection")) {
      output = <SchemeChip
        key={data.id}
        id={data.id}
        viewLang={viewLang}
        useIfWorkflow={useIfWorkflow}
        onDeleteIRI={onDeleteIRI}
        link={link}
        onLink={onLink}
        compact={compact}
        defaultLang={defaultLang}
        isReadOnly={!onDeleteIRI}
        graph={graph}
        avatar={data.type.includes("OrderedCollection") ?
          <ReorderIcon data-test="ordered-icon" fontSize="small" />
          :
          data.type.includes("Collection") ?
            <GrainIcon data-test="unordered-icon" fontSize="small" />
            :
            null
        }
        project={projectIRI} />;
    }
    else if (dataTypes.includes("Label")) {
      // Is it a free floating label?
      output = <FloatingLabelRelationshipLink
        id={data.id}
        link={link}
        onLink={onLink}
        graph={graph}
        isReadOnly={true}
        viewLang={viewLang}
        defaultLang={defaultLang} />;
    }
    else if (dataTypes.includes("Concept")) {
      output = <FloatingRelationshipLink
        id={data.id}
        link={link}
        onLink={onLink}
        graph={graph}
        isReadOnly={true}
        viewLang={viewLang}
        defaultLang={defaultLang} />;
    }
    else if (isNotLoaded) {
      output = <ExternalResourceLink
        id={id}
        graph={graph}
        isReadOnly={true} />;
    }
    else {
      return null;
    }

    return (
      wrap ?
        <div style={{ maxWidth: '100%' }}>
          {output}
        </div>
        :
        output
    );
  }
}

IriDisplay.defaultProps = {
  otherScheme: false,
  wrap: true,
  compact: false,
  useIfWorkflow: undefined
};

IriDisplay.propTypes = {
  isLoading: PropTypes.bool,
  useIfWorkflow: PropTypes.bool,
  onDeleteIRI: PropTypes.func,
  source: PropTypes.string,
  otherScheme: PropTypes.bool,
  compact: PropTypes.bool,
  property: PropTypes.string,
  propertyGraph: PropTypes.string,
  onLink: PropTypes.func,
  graph: PropTypes.string.isRequired,
  wrap: PropTypes.bool,
  components: PropTypes.array,
  defaultLang: PropTypes.string.isRequired,
  viewLang: PropTypes.string,
  projectIRI: PropTypes.string.isRequired
};

// We use concept load options but this will load various different resources types
// However it is just inScheme we need really so it's fine to do it this way 
// And keeping concept loading to a minimum which will be most common
export default withStyles(styles)(withGS(IriDisplay, ["ALL"], null, CONCEPT_LOAD_OPTIONS, true));